module.exports = __webpack_public_path__ + "img/ESF.3ff61f99.svg";